import React from 'react'
import ThemeWrapper from './ThemeWrapper'
import Header from './header'
import {
    AuthContext,
    NeighbourContext,
    ThemeModeContext,
} from './contexts/contexts'
import Footer from './general/footer'
import DebugInfoViewer from './data/viewers/debug-info-viewer'
import { BugReportRounded } from '@mui/icons-material'
import { Box, Fab } from '@mui/material'
import { requestNotificationPermission } from '../utils/functions'

export default function Layout({ children }) {
    const authContextValue = React.useContext(AuthContext)
    const neighbourContextValue = React.useContext(NeighbourContext)
    const [debugMode, setDebugMode] = React.useState(false)
    const { mode } = React.useContext(ThemeModeContext)
    const [community, setCommunity] = React.useState('')
    const [user, setUser] = React.useState(null)

    React.useEffect(() => {
        requestNotificationPermission()
    }, [])

    React.useEffect(() => {
        if (!authContextValue.loading) {
            if (authContextValue.userRef?.id) {
                setUser({
                    ...authContextValue.userData,
                    id: authContextValue.userRef?.id,
                })
            } else {
                setUser(authContextValue.userData)
            }
        }
    }, [authContextValue.loading, authContextValue.userData])

    React.useEffect(() => {
        if (!neighbourContextValue.loading) {
            if (neighbourContextValue.communityData) {
                {
                    process.env.NODE_ENV === 'development'
                        ? setCommunity(
                              `Comunidad: ${neighbourContextValue.communityData?.name} - ${neighbourContextValue.communityData?.id}`
                          )
                        : setCommunity(
                              `Comunidad: ${neighbourContextValue.communityData?.name}`
                          )
                }
            } else {
                setCommunity('')
            }
        }
    }, [neighbourContextValue.loading, neighbourContextValue.communityData])

    return (
        <ThemeWrapper mode={mode}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                }}
            >
                <Header
                    community={community}
                    loggedUser={user}
                    neighbour={neighbourContextValue?.neighbourData}
                ></Header>
                <main
                    style={{
                        display: 'flex',
                        flex: 1,
                        overflow: 'auto',
                        flexDirection: 'column',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                        }}
                    >
                        {children}
                    </div>
                    <div style={{ maxHeight: '100px' }}>
                        <Footer />
                    </div>
                </main>
                {process.env.NODE_ENV === 'development' ? (
                    <Fab
                        variant="contained"
                        aria-label="debug"
                        sx={{
                            cursor: 'default',
                            position: 'absolute',
                            bottom: 64,
                            left: 32,
                            opacity:
                                process.env.NODE_ENV === 'development' ? 1 : 0,
                        }}
                        onClick={() => setDebugMode(!debugMode)}
                    >
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <BugReportRounded />
                        </Box>
                    </Fab>
                ) : null}
                {debugMode ? <DebugInfoViewer /> : null}
            </div>
        </ThemeWrapper>
    )
}
